import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Jumbotron/Jumbotron';

class Jumbotron extends React.Component{

  render(){
    return (
      <div id="top" className="jumbotron" style={this.props.styles}>
        <div className="container">
          <div className={'fus-pitch ' + this.props.loadAnimation}>
            <div className={this.props.actionAnimation || ''}>
              <InlineEditableElement size={this.props.size} fontFamilyChanged={this.props.fontFamilyChanged.bind(this)} onChange={this.props.valueChanged.bind(this)} html={this.props.section.prop('content')} className="fus-call-to-action" inlineEditingEnabled={this.props.inlineEditingEnabled} />
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default hoc(Jumbotron);
